import { CurrencySchema, InvoiceReviewStatusSchema, PeriodSchema, RevenueBreakdownSchema } from '@weft/types';
import { oz } from '@weft/utils';
import { APPROVAL_FLOW_INVOICE_TYPES } from './approval-flow-invoice-types-query-params';

export const GetApprovalFlowInvoicesListResponseSchema = oz.object({
  invoiceId: oz.string(),
  invoiceName: oz.string(),
  invoicePeriod: PeriodSchema,
  invoiceTags: oz.nativeEnum(APPROVAL_FLOW_INVOICE_TYPES).array(),
  reviewStatus: InvoiceReviewStatusSchema,
  customerName: oz.string(),
  currency: CurrencySchema,
  contractName: oz.string().optional(),
  revenueBreakdown: RevenueBreakdownSchema,
}).array().openapi('GetApprovalFlowInvoicesListResponseSchema');

export type GetApprovalFlowInvoicesListResponse = oz.infer<typeof GetApprovalFlowInvoicesListResponseSchema>;